import src from "IMAGE";
export default { src, width: 1462, height: 622, blurWidth: 0, blurHeight: 0};
